'use strict'

const SELECTORS = {
    element: '.js-product-finder',
    form: '.js-product-finder-form',
    submitButton: '.js-product-finder-btn',
    continue: '.js-product-finder-continue',
    statusAnnouncer: '.js-status-announcer',
    backButton: '.js-back-button',
    resultsWrp: '.js-product-finder-results',
    question: '.js-finder-question',
    responseInput: '.js-response-input',
    answerOption: 'input[name="answer-option"]',
    resetBtn: '.js-reset-btn',
    selectedAnswers: 'input[type="radio"]:checked'
}

class ProductFinder {
    constructor(element) {
        this.element = element;
        this.form = element.find(SELECTORS.form);
        this.submitBtn = element.find(SELECTORS.submitButton);
        this.continue = element.find(SELECTORS.continue);
        this.statusAnnouncer = element.find(SELECTORS.statusAnnouncer);
        this.resultsWrp = element.find(SELECTORS.resultsWrp);
        this.question = element.find(SELECTORS.question);
        this.backButton = element.find(SELECTORS.backButton);
        this.responseInput = element.find(SELECTORS.responseInput);
        this.resetBtn = element.find(SELECTORS.resetBtn);
        this.simpleSurvey = element.data('component-logic') === 'simple';
        this.history = [];

        this.initEvents();
    }

    initEvents() {
        this.initializeQuestion();
        this.previousStep();
        this.nextStep();
        this.resetProductFinderSurvey();
        this.onResponseSelection();
        this.onFormSubmit();
    }

    initializeQuestion() {
        this.question.each((index, element) => {
            const questionAnswersOptions = $(element).find(SELECTORS.answerOption);
            const questionID = $(element).data('component-id');
            questionAnswersOptions.each((i, question) => {
                $(question).attr('name', 'answer-option-' + questionID);
            });

            if (!this.simpleSurvey) {
                $(element).attr('data-visible', index === 0);
                $(element).attr('data-index', index);
            }

            $(element).attr('aria-hidden', index === 0 ? 'false' : 'true');
        });
    }

    previousStep() {
        $(this.backButton).on('click', (e) => {
            e.preventDefault();
            if (this.simpleSurvey) {
                this.moveToStep(false);
            } else {
                const previousQuestionID = this.history.pop();
                const currentQuestionID = this.getCurrentQuestion().attr('data-question-id');
                this.continue.removeClass('d-none').attr('data-question-id', currentQuestionID);
                this.element.removeClass('cc-product-finder--last-step');
                this.moveToStep(false, previousQuestionID);
            }
        });
    }

    nextStep() {
        $(this.continue).on('click', (e) => {
            e.preventDefault();
            if (this.simpleSurvey) {
                this.moveToStep(true);
            } else {
                const nextQuestionID = $(e.currentTarget).attr('data-question-id');
                const currentQuestionID = this.getCurrentQuestion().attr('data-question-id');
                this.history.push(currentQuestionID);
                this.moveToStep(true, nextQuestionID);
            }
        });
    }

    resetProductFinderSurvey() {
        $(this.resetBtn).on('click', (evt) => {
            const currentQuestion = this.getCurrentQuestion();
            this.element.addClass('cc-product-finder--first-step').removeClass('cc-product-finder--last-step').removeClass('cc-product-finder--results-step');
            this.element.attr('data-step', 1);
            this.submitBtn.addClass('d-none').prop('disabled', true);
            this.resetBtn.addClass('d-none');
            this.continue.addClass('d-none');
            this.backButton.removeClass('d-none');
            this.resultsWrp.fadeOut({
                done: () => {
                    this.resultsWrp.empty();
                    this.resultsWrp.attr('aria-hidden', true);
                },
                duration: 500
            });
            this.question.find(SELECTORS.selectedAnswers).each((index, answer) => {
                $(answer).get(0).checked = false;
            });
            $(this.question[0]).parent().fadeIn();
            $(this.question[0]).attr('data-visible', true);
            $(this.question[0]).attr('aria-hidden', false);
            const heading = $(this.question[0]).find('.js-product-finder-question-title');
            heading.attr('tabindex', '-1').focus();
            this.history = [];
        });
    }

    onResponseSelection() {
        this.responseInput.on('change', (e) => {
            const $target = $(e.currentTarget);
            const isChecked = $target.is(":checked");
            const dataStep = parseInt(this.element.attr('data-step'));
            const dataSize = parseInt(this.element.attr('data-size'), 10);
            const textAnnouncer = this.statusAnnouncer.data('announcer-text') || '';

            if (!this.simpleSurvey) {
                const relatedQuestionID = $target.attr('data-question');
                this.continue.attr('data-question-id', relatedQuestionID);
                const currentQuestionID = $target.closest(SELECTORS.question).attr('data-question-id');
                this.backButton.attr('data-question-id', currentQuestionID);

                if (relatedQuestionID && relatedQuestionID.length > 0) {
                    this.continue.removeClass('d-none');
                    this.statusAnnouncer.text(textAnnouncer);
                    this.element.removeClass('cc-product-finder--last-step');
                } else {
                    this.continue.addClass('d-none');
                    this.submitBtn.removeClass('d-none').removeAttr('disabled');
                    this.element.addClass('cc-product-finder--last-step');
                }
            } else {
                this.continue.toggleClass('d-none', !isChecked);
                if (isChecked && dataStep === dataSize) {
                    this.submitBtn.removeClass('d-none').removeAttr('disabled');
                } else {
                    this.submitBtn.addClass('d-none').prop('disabled', true);
                }
            }
        });
    }

    onFormSubmit() {
        this.form.on('submit', (e) => {
            e.preventDefault();

            $.spinner().start();

            const url = this.form.attr('action');

            let filteredProductIds = [];

            this.question.find(SELECTORS.selectedAnswers).each((index, answer) => {
                const inputValues = JSON.parse($(answer).val());

                if (index === 0) {
                    filteredProductIds = filteredProductIds.concat(inputValues);
                } else {
                    let temporaryArr = inputValues;
                    filteredProductIds = temporaryArr.filter((value) => {
                        return filteredProductIds.includes(value);
                    });
                }
            });

            const data = {
                productsIDs: JSON.stringify(filteredProductIds)
            };

            $.ajax({
                url: url,
                type: "GET",
                dataType: "json",
                data: data,
                success: (response) => {
                    this.element.removeClass('cc-product-finder--last-step').addClass('cc-product-finder--results-step');
                    this.resetBtn.removeClass('d-none');
                    this.backButton.addClass('d-none');
                    this.submitBtn.addClass('d-none').prop('disabled', true);
                    const currentQuestion = this.getCurrentQuestion();
                    currentQuestion.attr('data-visible', false);
                    currentQuestion.attr('aria-hidden', true);
                    currentQuestion.parent().fadeOut({
                        done: function () {
                            currentQuestion.attr('data-visible', false);
                        },
                        duration: 500
                    });
                    this.productFinderResults(response);
                },
                error: (error) => {
                    console.error(error);
                    $.spinner().stop();
                }
            });

        });
    }

    moveToStep(nextStep, nextQuestionID = '') {
        let currentQuestion = undefined;
        let nextQuestion = undefined;

        if (nextQuestionID.length > 0) {
            currentQuestion = $(SELECTORS.question + '[data-visible="true"]');
            nextQuestion = $(`${SELECTORS.question}[data-question-id="${nextQuestionID}"]`);
            currentQuestion.parent().fadeOut({
                done: function () {
                    currentQuestion.attr('data-visible', false);
                },
                duration: 500
            });
            nextQuestion.parent().fadeIn({
                done: function () {
                    nextQuestion.attr('data-visible', true);
                    this.question.attr('aria-hidden', true);
                    nextQuestion.attr('aria-hidden', false);
                    const heading = nextQuestion.find('.js-product-finder-question-title');
                    heading.attr('tabindex', '-1').focus();
                }.bind(this),
                duration: 500
            });

            this.element.toggleClass('cc-product-finder--first-step', this.history.length === 0);
            this.resetBtn.addClass('d-none');
        } else {
            const dataStep = this.element.attr('data-step');
            const dataSize = parseInt(this.element.attr('data-size'), 10);
            let step = parseInt(dataStep, 10);
            currentQuestion = this.getCurrentQuestion();
    
            step = nextStep ? step + 1 : step - 1;
            this.element.attr('data-step', step);
    
            nextQuestion = this.getCurrentQuestion();
            currentQuestion.parent().fadeOut(500);
            nextQuestion.parent().fadeIn(500);
            this.question.attr('aria-hidden', 'true');

            nextQuestion.attr('aria-hidden', 'false');
            const heading = nextQuestion.find('.js-product-finder-question-title');
            heading.attr('tabindex', '-1').focus();
    
            this.element.toggleClass('cc-product-finder--last-step', step == dataSize);
            this.element.toggleClass('cc-product-finder--first-step', step - 1 === 0);
            this.resetBtn.addClass('d-none');
    
            // const isNextQuestionAnswered = nextQuestion.find('input[type="radio"]:checked').length > 0;
            // if (step === dataSize && isNextQuestionAnswered) {
            //     this.submitBtn.removeClass('d-none').removeAttr('disabled');
            // }
        }

        if (!nextStep) {
            const currentAnswer = currentQuestion.find('input[type="radio"]:checked');
            if (currentAnswer.length > 0) currentAnswer.get(0).checked = false;

            this.submitBtn.addClass('d-none').prop('disabled', true);
        } else {
            this.continue.addClass('d-none');
        }
    }

    getCurrentQuestion() {
        if (this.simpleSurvey) {
            const dataStep = this.element.attr('data-step');
            return $(this.question[dataStep - 1]);
        }

        return $(SELECTORS.question + '[data-visible="true"]');
    }

    async productFinderResults(response) {
        this.question.attr('aria-hidden', true);
        this.resultsWrp.show();
        this.resultsWrp.attr('aria-hidden', false);
        this.resultsWrp.empty();
        this.resultsWrp.html(response.renderedTemplate);
        console.log(this.resultsWrp.html());
        const hasProducts = this.resultsWrp.find('.js-tile').length > 0;
        const resultsTitle = this.element.find('.js-product-finder-results').data('response-title') || '';
        const resultsNoResultsTitle = this.element.find('.js-product-finder-results').data('response-title-no-results') || '';
        this.element.find('.js-product-finder-results .cc-section-slider__title').text(resultsTitle);
        if (!hasProducts) {
            this.resultsWrp.html('<div class="cc-product-finder__no-results"><p class="cc-product-finder__no-results__text" aria-live="assertive">' + resultsNoResultsTitle + '</p></div>');
        } else {
            const resultsTitleElement = this.resultsWrp.find('.js-product-finder-results-title');
            resultsTitleElement.attr('tabindex', '-1').focus();
        }
        $('body').trigger('reinitSlick');
        $('body').trigger('swatchSelector:init');
        $.spinner().stop();
    }
}

module.exports = () => {
    $(SELECTORS.element).each((index, element) => {
        new ProductFinder($(element));
    });
}